export default __webpack_public_path__ + "static/media/lesson-builder-blue.6348b7d7.svg";